import { Fragment, useState, useEffect } from "react";
import { Button, Spin, Result } from "antd";
import { Searcher, TableAntd, TitleHeader } from "../../components/commons";
import { getGanadores, downloadExcelGanadores } from "../../api/sorteo";
import { FileExcelOutlined } from "@ant-design/icons";
import { columnsParticipantes } from "./formatTable";
import { useHistory } from "react-router-dom";
// import { generaByCodigoSorteo } from "../../api/credencial";

function ListaSorteo(props) {
  const [filterTable, setFilterTable] = useState(null);
  const [page, setPage] = useState(1);

  const codigosorteo = props.match.params.codigo;

  const [dataToTable, setDataToTable] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const history = useHistory();

  const [recordSorteo, setRecordSorteo] = useState({
    nombre: "",
    isActivo: null
  });

  const fetchDataToTable = async () => {
    try {
      setIsLoading(true);
      const res = await getGanadores(codigosorteo);
      setDataToTable(res.payload.ganadores);
      setRecordSorteo(res.payload.sorteo);
    } catch (error) {
      setError(error);
      setIsError(true);
      setDataToTable([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDataToTable();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <Spin tip="Cargando" className="w-full py-60" />;
  }

  if (isError) {
    return (
      <Result
        status="500"
        title="Algo salió mal"
        subTitle={error.message}
        extra={
          <Button onClick={() => window.location.reload()} type="primary">
            Recargar
          </Button>
        }
      />
    );
  }

  const onSearch = (value) => {
    const tempFilterTable = dataToTable.filter((o) =>
      Object.keys(o).some((k) => String(o[k]).toLowerCase().includes(value.toLowerCase()))
    );

    setFilterTable(tempFilterTable);
  };

  // ------------- Descarga ganadores por codigo -------------
  const onDownloadGanadoresExcel = async () => {
    const blob = await downloadExcelGanadores(codigosorteo);

    // 2. Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `ganadores-${codigosorteo}.xlsx`);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);
  };

  const handleGenerateCredentials = async () => {
    console.log("handleGenerateCredentials");
    // try {
    //   const data = { codigosorteo };
    //   const response = await generaByCodigoSorteo(data);
    //   message.success(response.message);
    // } catch (err) {
    //   message.error(err.message);
    // }
  };

  // ------ Formato para que se muestre en la tabla ------
  const columnsToTable = columnsParticipantes(page);

  return (
    <Fragment>
      {/* <div className="my-4 gap-4 mr-4 flex flex-col flex-wrap  md:flex-row justify-between md:flex-nowrap">
        <span className="font-bold text-lg ">({dataToTable.length || 0}) GANADORES DEL SORTEO</span>

        <div className="flex gap-1 flex-col flex-wrap  md:flex-row md:flex-nowrap">
          <Button
            disabled={!dataToTable.length}
            onClick={onDownloadGanadoresExcel}
            icon={<FileExcelOutlined />}
            className="text-white rounded-md text-xs bg-green-500 hover:bg-green-600 hover:shadow-lg"
          >
            Descargar
          </Button>
        </div>
      </div> */}

      <TitleHeader
        title={`(${dataToTable.length || 0}) GANADORES DEL SORTEO`}
        onBack={() => history.goBack()}
        extra={
          <div className="flex gap-4">
            <Button
              disabled={!dataToTable.length}
              onClick={handleGenerateCredentials}
              className="text-white rounded-md text-xs bg-yellow-500 hover:bg-yellow-600 hover:shadow-lg"
            >
              Generar credenciales
            </Button>
            <Button
              disabled={!dataToTable.length}
              onClick={onDownloadGanadoresExcel}
              icon={<FileExcelOutlined />}
              className="text-white rounded-md text-xs bg-green-500 hover:bg-green-600 hover:shadow-lg"
            >
              Descargar
            </Button>
          </div>
        }
      />

      <div className="flex my-2 text-lg">
        <div>
          Nombre:&nbsp;
          <span className="font-bold text-blue-500">{recordSorteo.nombre}</span>
        </div>

        <div>
          &nbsp;Código:&nbsp;
          <span className="font-bold text-blue-500">{codigosorteo}</span>
        </div>

        <div>
          &nbsp;Publicado:&nbsp;
          <span className="font-bold text-blue-500">{recordSorteo.isActivo ? "Sí" : "No"}</span>
        </div>
      </div>

      <Searcher onSearch={onSearch} placeholder="Busca algún posible participante" />

      <TableAntd
        columns={columnsToTable}
        dataSource={filterTable == null ? dataToTable : filterTable}
        pageSize={100}
        setPage={setPage}
      />
    </Fragment>
  );
}

export default ListaSorteo;
